import { File } from './index';

export interface Merchant {
  _id?: string;
  nanoid?: string;
  name?: string;
  type?: string;
  admins?: string[];
  logo?: File;
  active?: boolean;
  hasNFC?: boolean;
  dismissedNotices?: string[];
  timezone?: string;
  country?: {
    name?: string;
    code?: string;
  };
  reports?: {
    week: boolean;
    month: boolean;
  };
  conversations?: {
    active?: boolean;
    emailNotifications?: boolean;
    canBeMessaged?: boolean;
    info?: string;
  };
  onboard?: {
    location: boolean;
    reward: boolean;
    card: boolean;
  };
  customBranding?: boolean;
  stripeMerchantId?: string;
  microsite?: {
    enabled?: boolean;
    approved?: boolean;
    subdomain?: string;
    branding?: {
      settings?: {
        radius?: number;
        title?: string;
        googleAnalyticsId?: string;
      };
      logo?: File;
      cover?: File;
      emailArtwork?: File;
      name?: string;
      colors?: {
        background?: string;
        text?: string;
        button?: string;
        buttonText?: string;
        discount?: string;
        discountText?: string;
      };
      contact?: {
        phone?: string;
        email?: string;
        website?: string;
        address?: {
          line1?: string;
          line2?: string;
          city?: string;
          postalCode?: string;
          country?: string;
        };
      };
      font?: {
        family?: string;
        googleFontsUrl?: string;
      };
    };
  };
}
